import PropTypes from "prop-types"
import { get } from "lodash"
import { formatLongDate, formatLongDateTime } from "helpers/formatters/dates"
import { DATE } from "helpers/shapes"
import TooltipItem from "./item"

function AnalyzeTooltip({ datum, items, formatter, focusedChartLine, isOneDayMode }) {
  if (datum) {
    const headerText = isOneDayMode ? formatLongDateTime(datum.date) : formatLongDate(datum.date)
    return <div className="components_analyze-tooltip">
      <div className="header">{headerText}</div>
      {items.map(item => !item.disabled && <TooltipItem
        key={item.id}
        value={get(datum, item.id, "--")}
        {...item}
        focused={focusedChartLine}
        formatter={formatter}
      />,
      )}
    </div>
  } else {
    return null
  }
}

AnalyzeTooltip.propTypes = {
  formatter: PropTypes.func,
  focusedChartLine: PropTypes.string,
  datum: PropTypes.shape({
    date: DATE.isRequired,
    index: PropTypes.number,
  }),
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  })).isRequired,
  isOneDayMode: PropTypes.bool,
}

export default AnalyzeTooltip
